"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _warehouse = require("@/api/warehouse");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _reportExcel = require("./components/report-excel");
var _date = require("@/utils/date");
var ReportWarehouse = /*#__PURE__*/function (_Vue) {
  function ReportWarehouse() {
    var _this;
    (0, _classCallCheck2.default)(this, ReportWarehouse);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ReportWarehouse, [].concat(args));
    (0, _defineProperty2.default)(_this, "tabName", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "date", [(0, _moment.default)().clone().startOf("month").format("YYYY-MM-DD"), (0, _moment.default)().clone().endOf("month").format("YYYY-MM-DD")]);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "dataExport", []);
    (0, _defineProperty2.default)(_this, "ExportExcelType", _reportExcel.ExportExcelType);
    return _this;
  }
  (0, _inherits2.default)(ReportWarehouse, _Vue);
  return (0, _createClass2.default)(ReportWarehouse, [{
    key: "transformData",
    get: function get() {
      var data = [];
      this.data.forEach(function (e) {
        var temp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
          rowspan: 0,
          totalRemain: 0
        });
        if (e.details.length) {
          e.details.forEach(function (detail) {
            temp = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, temp), detail), {}, {
              totalRemain: detail.remainConsign
            });
            data.push(temp);
          });
        } else {
          data.push(temp);
        }
      });
      var count = 0;
      data.forEach(function (element, index) {
        count++;
        if (index < data.length - 1 && element.id != data[index + 1].id) {
          data[index + 1 - count].rowspan = count;
          count = 0;
        }
      });
      if (data.length) {
        data[data.length - count].rowspan = count;
      }
      return data;
    }
  }, {
    key: "watchTabName",
    value: function watchTabName(val) {
      if (val == "report") {
        this.fetchData();
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "getExpired",
    value: function getExpired(date) {
      return (0, _date.diffDayFromToday)(date);
    }
  }, {
    key: "getPercentExpired",
    value: function getPercentExpired(data) {
      return (0, _date.percentFromCurrentToExpired)(data.expired, data.dateOfManufacture);
    }
  }, {
    key: "handleExport",
    value: function () {
      var _handleExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(type) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.fetchDataExport(type);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleExport(_x) {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }()
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.query.from = this.date[0];
      this.query.to = this.date[1];
      this.loading = true;
      _warehouse.warehouseApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters)).then(function (res) {
        _this2.data = res.data.products;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "fetchDataExport",
    value: function () {
      var _fetchDataExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(type) {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters);
              delete query.page;
              delete query.limit;
              _context2.next = 5;
              return _warehouse.warehouseApi.findAll(query);
            case 5:
              res = _context2.sent;
              (0, _reportExcel.reportWarehouseExcel)({
                data: res.data.products,
                type: type,
                date: [query === null || query === void 0 ? void 0 : query.from, query === null || query === void 0 ? void 0 : query.to]
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDataExport(_x2) {
        return _fetchDataExport.apply(this, arguments);
      }
      return fetchDataExport;
    }()
  }, {
    key: "objectSpanMethod",
    value: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ReportWarehouse.prototype, "tabName", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("tabName")], ReportWarehouse.prototype, "watchTabName", null);
ReportWarehouse = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], ReportWarehouse);
var _default = exports.default = ReportWarehouse;